import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';

export default {
  refreshPage() {
    location.reload();
  },
  // toggleEditMode(context) {
  //     context.commit('TOGGLE_EDIT_MODE');
  // },
  // toggleActiveMode(context) {
  //     context.commit('TOGGLE_ACTIVE_MODE');
  // },
  // addToChangeList(context, payload) {
  //     context.commit('ADD_TO_CHANGE_LIST', payload);
  // },
  // setUpdatePrice(context, payload) {
  //     context.commit('SET_LOADING', payload);
  // },
  // updatePrice(context, payload) {
  //     context.commit('UPDATE_PRICE', payload);
  // },
  // toggleModelType(context) {
  //     context.commit('TOGGLE_MODEL_TYPE');
  // },
  // updateVueModel(context, payload) {
  //     context.commit('UPDATE_VUE_MODEL', payload);
  // },
  closeModal({ commit }) {
    commit('SET_MODAL_VISIBILITY', false);
  },
  cancelSaveProposal({ commit, dispatch }) {
    commit('SET_MODAL_VISIBILITY', false);
    dispatch('registerEvent', 'policy-view-cancel-save-proposal');
  },
  // setHullWarning({commit}, payload) {
  //     commit('SET_HULL_WARNING', payload);
  // },
  setBasketPosition({ commit }, payload) {
    commit('SET_BASKET_POSITION', payload);
  },
  goToPolicyOnSelfServicePage({ state }) {
    location.href = '/#' + state.vueModel.ExternalPolicyNumber;
  },
  goToSelfServicePage() {
    location.href = '/';
  },
  goTo404Page() {
    location.href = '/404';
  },
  goToError500Page() {
    location.href = '/ErrorPage';
  },
  confirmLeaveDetailsPage({ commit, dispatch, state, getters }) {
    if (state.editMode && getters.anyChanges) {
      commit('SET_MODAL_DATA', {
        title: state.vueModel.Modals.ConfirmLeaveDetailsPageWarning.Title,
        content: state.vueModel.Modals.ConfirmLeaveDetailsPageWarning.Content,
        buttons: [
          {
            label: state.vueModel.Modals.ConfirmLeaveDetailsPageWarning.ButtonCancelLabel,
            action: 'policy/closeModal',
            spinner: false,
            secondary: false
          },
          {
            label: state.vueModel.Modals.ConfirmLeaveDetailsPageWarning.ButtonContinueLabel,
            action: 'policy/leaveDetailsPage',
            spinner: false,
            secondary: true
          }
        ]
      });
      return commit('SET_MODAL_VISIBILITY', true);
    }

    return dispatch('goToPolicyOnSelfServicePage');
  },
  // ENDPOINT ACTIONS
  // ---------------------------------------
  // LEAVE DETAILS PAGE
  leaveDetailsPage({ dispatch, state }) {
    const data = state.vueModel.SaveEndorsementTemplate.PortalId;
    return axios
      .get(Utility.constants().API.policy_edit_cancel + '/' + data)
      .then(() => {
        dispatch('goToPolicyOnSelfServicePage');
      })
      .catch(() => {
        dispatch('goToPolicyOnSelfServicePage');
      });
  },

  // GET
  setInitialModel({ commit, dispatch }, payload) {
    return axios
      .get(Utility.constants().API.policy_get + payload)
      .then((response) => {
        commit('UPDATE_VUE_MODEL', response.data);
      })
      .catch((error) => {
        let goToAction = 'goToError500Page';
        if (typeof error.response !== 'undefined') {
          if (
            error.response.status === 400 ||
            error.response.status === 401 ||
            error.response.status === 404
          ) {
            goToAction = 'goTo404Page';
          }
        }
        Utility.logError(error, this);
        dispatch(goToAction);
      });
  },

  // ACTIVATE EDIT MODE
  activateEditMode({ commit, state }, payload) {
    commit('SET_INITIAL_VUE_MODEL');
    commit('SET_LOADING', true);

    return axios
      .get(Utility.constants().API.policy_edit_initiate + payload)
      .then((response) => {
        commit('UPDATE_VUE_MODEL', response.data);
        commit('SET_EDIT_MODE_ACTIVATED', true);
        commit('SET_LOADING', false);
        commit('UPDATE_PRICE', response.data.Price.PriceFormatted);
      })
      .catch(() => {
        commit('SET_LOADING', false);
        commit('SET_MODAL_DATA', {
          title: state.vueModel.Modals.ActivateEditModeError.Title,
          content: state.vueModel.Modals.ActivateEditModeError.Content,
          buttons: [
            {
              label: state.vueModel.Modals.ActivateEditModeError.ButtonCancelLabel,
              action: 'policy/closeModal',
              spinner: false,
              secondary: false
            }
          ]
        });
        commit('SET_MODAL_VISIBILITY', true);
      });
  },

  // CANCEL EDIT MODE
  cancelEditMode({ commit, state, dispatch }) {
    const data = state.vueModel.SaveEndorsementTemplate.PortalId;
    dispatch('registerEvent', 'policy-view-cancel-edit-mode');
    axios
      .get(Utility.constants().API.policy_edit_cancel + '/' + data)
      .then(() => {
        commit('RESTORE_INITIAL_VUE_MODEL');
        commit('SET_EDIT_MODE_ACTIVATED', false);
        commit('SET_MODAL_VISIBILITY', false);
      })
      .catch(() => {
        commit('RESTORE_INITIAL_VUE_MODEL');
        commit('SET_EDIT_MODE_ACTIVATED', false);
        commit('SET_MODAL_VISIBILITY', false);
      });
  },

  // CALCULATE NEW PRICE
  calculateNewPrice({ commit, state }, payload) {
    commit('SET_LOADING', true);
    axios
      .post(payload.endpoint, payload.templateModel)
      .then((response) => {
        commit('UPDATE_VUE_MODEL', response.data);
        commit('SET_LOADING', false);
        commit('UPDATE_PRICE', response.data.Price.PriceFormatted);
      })
      .catch(() => {
        commit('SET_LOADING', false);
        commit('SET_MODAL_DATA', {
          title: state.vueModel.Modals.CalculatePriceError.Title,
          content: state.vueModel.Modals.CalculatePriceError.Content,
          buttons: [
            {
              label: state.vueModel.Modals.CalculatePriceError.ButtonCancelLabel,
              action: 'policy/cancelEditMode',
              spinner: false,
              secondary: false
            }
          ]
        });
        commit('SET_MODAL_VISIBILITY', true);
      });
  },

  // CONFIRM SAVE PROPOSAL
  confirmSaveProposal({ commit, state, dispatch }) {
    commit('SET_MODAL_DATA', {
      name: 'confirmSaveProposal',
      title: state.vueModel.Modals.ConfirmSaveProposal.Title,
      content: state.vueModel.Modals.ConfirmSaveProposal.Content,
      buttons: [
        {
          label: state.vueModel.Modals.ConfirmSaveProposal.ButtonContinueLabel,
          action: 'policy/saveProposal',
          spinner: true,
          secondary: false
        },
        {
          label: state.vueModel.Modals.ConfirmSaveProposal.ButtonCancelLabel,
          action: 'policy/cancelSaveProposal',
          spinner: false,
          secondary: true
        }
      ]
    });

    commit('SET_MODAL_VISIBILITY', true);
    dispatch('registerEvent', 'policy-view-save-changes');
  },

  // SAVE PROPOSAL
  saveProposal({ commit, state, dispatch }) {
    const api = state.vueModel.SaveEndorsementTemplate.ApiEndpoint;
    const data = state.vueModel.SaveEndorsementTemplate;

    commit('SET_LOADING', true);

    return axios
      .post(api, data)
      .then((response) => {
        const data = response.data;
        const isSuccess = data.IsSuccess;

        if (!isSuccess) {
          commit('SET_LOADING', false);
          commit('SET_MODAL_DATA', {
            title: data.FrontEndTitleMessage,
            content: data.FrontEndContentMessage,
            buttons: [
              {
                label: state.vueModel.Modals.SaveProposalError.ButtonCancelLabel,
                action: 'policy/refreshPage',
                spinner: false,
                secondary: false
              },
              {
                label: state.vueModel.Modals.SaveProposalError.ButtonContinueLabel,
                action: 'policy/goToPolicyOnSelfServicePage',
                spinner: false,
                secondary: true
              }
            ]
          });
          dispatch('registerEvent', 'policy-view-save-proposal-success-error');
        } else {
          commit('SET_MODAL_VISIBILITY', false);
          commit('SET_VIEW_MODE', 2);
          dispatch('registerEvent', 'policy-view-save-proposal-ok');
        }

        commit('SET_LOADING', false);
        commit('SET_EDIT_MODE_ACTIVATED', false);
      })
      .catch(() => {
        commit('SET_LOADING', false);
        commit('SET_MODAL_DATA', {
          title: state.vueModel.Modals.SaveProposalError.Title,
          content: state.vueModel.Modals.SaveProposalError.Content,
          buttons: [
            {
              label: state.vueModel.Modals.SaveProposalError.ButtonCancelLabel,
              action: 'policy/cancelEditMode',
              spinner: false,
              secondary: false
            },
            {
              label: state.vueModel.Modals.SaveProposalError.ButtonContinueLabel,
              action: 'policy/goToPolicyOnSelfServicePage',
              spinner: false,
              secondary: true
            }
          ]
        });
        dispatch('registerEvent', 'policy-view-save-proposal-api-error');
      });
  },

  registerEvent({ state, dispatch }, payload) {
    dispatch(
      'Events/register',
      {
        event: payload,
        id: 'policyView',
        vm: state.vueModel
      },
      {
        root: true
      }
    );
  }
};
